import { createFileRoute, redirect } from '@tanstack/react-router';

// Renamed to /reports. Kept as a redirect so existing bookmarks, deep links,
// and any external references to /analytics keep working.
export const Route = createFileRoute('/analytics')({
  beforeLoad: () => {
    throw redirect({ to: '/reports' });
  },
});
